module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-XBold Italic.5a6e0f99.woff2";